import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/api";
import { useAuth } from "@/auth/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser, setIsAuthenticated } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    const run = async () => {
      if (processed.current) return;
      processed.current = true;

      try {
        const hash = window.location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        const sessionId = match ? decodeURIComponent(match[1]) : null;
        if (!sessionId) {
          setIsAuthenticated(false);
          navigate("/login", { replace: true });
          return;
        }

        const res = await api.post("/auth/oauth/session", { session_id: sessionId });
        setUser(res.data.user);
        setIsAuthenticated(true);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { replace: true });
      } catch (e) {
        setIsAuthenticated(false);
        navigate("/login", { replace: true });
      }
    };

    run();
  }, [navigate, setIsAuthenticated, setUser]);

  return (
    <div data-testid="auth-callback-loading" className="min-h-screen bg-slate-950 text-slate-100 flex items-center justify-center">
      <div className="w-full max-w-md px-6">
        <div className="rounded-2xl border border-slate-800 bg-slate-900/40 p-6">
          <div className="text-base text-slate-200" data-testid="auth-callback-title">
            Signing you in…
          </div>
          <div className="mt-2 text-sm text-slate-400" data-testid="auth-callback-subtitle">
            Finishing Google authentication.
          </div>
        </div>
      </div>
    </div>
  );
}
